import Spinner from '../spinner/Spinner';
import Footer from '../footer/Footer';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../assets/styles/TopHeader.css'; // Make sure this path is correct
import bannerImageUrl from '../../assets/images/privacy.jpg';
import Arise4uBlackLogo from '../../assets/images/logo/arise logo 95.svg';

const PrivacyPolicy = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const headerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY > 50) {
          headerRef.current.classList.add('sticky');
        } else {
          headerRef.current.classList.remove('sticky');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* The main container fragment */}
      <>
        <section
          ref={headerRef}
          className="privacy-header-banner"
          style={{ backgroundImage: `url(${bannerImageUrl})` }}
        >
          <div className="privacy-header-content-wrapper">
          

            <section className="privacy-hero-section">
              <h1 className="privacy-hero-title font-bold">Privacy Policy</h1>
            </section>
          </div>
        </section>


        <section className='legalpage-container mb-5'>
          <div className='custom-padding-three'>
            <div className='legalpage-contents mt-3 pt-3 mt-md-5'>
              <div>
                <p className='font-medium fs-5 '>
                  This Privacy Policy (“Policy”) governs the manner in which HCLTech, Pearson, MSH and Thought Pencil collect, use, maintain, and disclose information collected from users (“Users”, “You” or “Participants”) of the ARISE FOR YOU™ program. This Policy is issued in compliance with the Information Technology Act, 2000, and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011.
                </p>
                <p className='font-medium fs-5 '>
                  By registering for or participating in the ARISE FOR YOU Program, you agree to the terms outlined in this Privacy Policy.
                </p>
              </div>
              <div className='mt-5'>
                <>
                  <h2 className="mb-3 font-bold txt-blue">1.1 SCOPE AND APPLICABILITY</h2>
                  <ul>
                    <li className='font-medium fs-5 '>This Policy applies to all participants, students, mentors, channel partners, and stakeholders involved in the ARISE FOR YOU Program across India.</li>
                    <li className='font-medium fs-5 '>All personal data will be used in accordance with the program’s privacy policy.</li>
                    <li className='font-medium fs-5 '>By participating, participants consent to the use of their name, image, videos, and submissions for promotional, editorial, or educational purposes in any media format.</li>
                    <li className='font-medium fs-5 '>No additional compensation will be provided for the use of the media, and participants waive any claims arising from such usage.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.2 ENTITIES INVOLVED IN DATA COLLECTION AND MANAGEMENT</h2>
                  <ul>
                    <li className="font-medium fs-5">HCL Technologies Limited</li>
                    <li className="font-medium fs-5">Pearson Education India Services Private Limited</li>
                    <li className="font-medium fs-5">Authorized Partner - Thought Pencil Communications Pvt Ltd</li>
                    <li className="font-medium fs-5">Authorized partners and service providers engaged in connection with the Program (including but not limited to marketing agencies, technology platforms, evaluation committees, and government bodies like MeitY Startup Hub where applicable from Phase 2 onwards).</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.3 INFORMATION WE COLLECT</h2>
                  <p className="font-medium fs-5">We may collect the following categories of Personal Information and Personal Data or Information (SPDI):</p>
                  <ul>
                    <li className="font-medium fs-5"><strong>Personal Identification Information:</strong> Name, age, gender, photograph, contact details (email address, phone number, residential address).</li>
                    <li className="font-medium fs-5"><strong>Academic and Professional Information:</strong> College/university name, course details, academic records, employment history (for faculty and mentors).</li>
                    <li className="font-medium fs-5"><strong>Payment and Transactional Information:</strong> Payment confirmation, transaction IDs related to program fees.</li>
                    <li className="font-medium fs-5"><strong>Certification Information:</strong> Results, evaluation scores, and certifications earned through Pearson ESB and related platforms.</li>
                    <li className="font-medium fs-5"><strong>Technical Information:</strong> IP addresses, browser type, device information, cookies, and usage patterns.</li>
                  </ul>
                  <p className="font-medium fs-5 mt-3">We do not collect biometric, health-related, or religious/political belief data as part of this Program.</p>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.4 PURPOSE OF DATA COLLECTION</h2>
                  <ul>
                    <li className="font-medium fs-5">To register and manage participation in the ARISE FOR YOU™ Program.</li>
                    <li className="font-medium fs-5">To facilitate e-learning and certification processes.</li>
                    <li className="font-medium fs-5">To evaluate entries, business ideas, and rank participants according to program rubrics.</li>
                    <li className="font-medium fs-5">To contact participants for mentorship, events, and prize disbursement.</li>
                    <li className="font-medium fs-5">To generate analytics, insights, and reports for internal program improvement and government reporting (where required under applicable regulations).</li>
                    <li className="font-medium fs-5">To comply with legal and regulatory requirements.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.5 DATA STORAGE AND RETENTION</h2>
                  <ul>
                    <li className="font-medium fs-5">The personal data collected will be securely stored on servers managed by HCLTech, Pearson, Thought Pencil Communications, MSH and authorized partners.</li>
                    <li className="font-medium fs-5">Data will be retained for as long as required to fulfill the purpose outlined in this Policy or as required under applicable laws.</li>
                    <li className="font-medium fs-5">Certification records may be retained indefinitely for verification and validation purposes.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.6 DATA SHARING AND DISCLOSURE</h2>
                  <p className="font-medium fs-5">Your information may be shared under the following circumstances:</p>
                  <ul>
                    <li className="font-medium fs-5">With Pearson and its affiliated entities for certification processing.</li>
                    <li className="font-medium fs-5">With government bodies like MeitY Startup Hub for mentoring and incubation support.</li>
                    <li className="font-medium fs-5">With authorized partners and service providers bound by confidentiality agreements and non-disclosure clauses.</li>
                    <li className="font-medium fs-5">Under legal obligation, such as to comply with a subpoena, court order, or regulatory directive.</li>
                  </ul>
                  <p className="font-medium fs-5 mt-3">We will not sell, rent, or trade your personal information to third parties for marketing purposes.</p>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.7 RIGHTS OF PARTICIPANTS</h2>
                  <p className="font-medium fs-5">In accordance with applicable Indian privacy laws, participants have the right to:</p>
                  <ul>
                    <li className="font-medium fs-5">Access and review their personal data held by us.</li>
                    <li className="font-medium fs-5">Request corrections or updates to inaccurate or incomplete data.</li>
                    <li className="font-medium fs-5">Withdraw consent for specific data processing activities (except where legally or contractually obligated).</li>
                    <li className="font-medium fs-5">Request deletion of their personal data, subject to legal retention obligations.</li>
                  </ul>
                  <p className="font-medium fs-5 mt-3">Requests can be made by contacting the Data Protection Officer at: <a href="mailto:karthikeyan.durai@hcltech.com">karthikeyan.durai@hcltech.com</a></p>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.8 SECURITY MEASURES</h2>
                  <ul>
                    <li className="font-medium fs-5">Implementation of information security standards.</li>
                    <li className="font-medium fs-5">Use of SSL encryption for all financial transactions and sensitive data exchanges.</li>
                    <li className="font-medium fs-5">Controlled access mechanisms, multi-factor authentication, and regular data protection audits.</li>
                    <li className="font-medium fs-5">Confidentiality training for all personnel handling personal information.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.9 COOKIES AND TRACKING TECHNOLOGIES</h2>
                  <ul>
                    <li className="font-medium fs-5">The ARISE FOR YOU™ website and associated digital platforms may use cookies to enhance user experience, analyze traffic, and personalize content. Users can modify browser settings to manage cookie preferences.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.10 CHANGES TO THIS PRIVACY POLICY</h2>
                  <ul>
                    <li className="font-medium fs-5">We reserve the right to update this Privacy Policy at any time. Changes will be noticed via email or website announcements. Continued participation in the Program after such changes shall constitute your consent to the updated terms.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.11 CONTACT INFORMATION</h2>
                  <p className="font-medium fs-5">For any queries, concerns, or grievances related to privacy, please contact:</p>
                  <p className="font-medium fs-5 mt-3">
                    <strong>Karthikeyan Duraipandian</strong><br />
                    HCL Technologies Limited<br />
                    Email: <a href="mailto:karthikeyan.durai@hcltech.com">karthikeyan.durai@hcltech.com</a>
                  </p>
                  <p className="font-medium fs-5 mt-3">Or</p>
                  <p className="font-medium fs-5 mt-3">
                    <strong>Rohith YSS</strong><br />
                    Thought Pencil Communications Pvt Ltd<br />
                    Email: <a href="mailto:finance@thoughtpencil.com">finance@thoughtpencil.com</a><br />
                    5-2 Maharaja Surya Rao Rd<br />
                    Dutch Village<br />
                    Vania Teynampet, Chennai<br />
                    Tamil Nadu - 600018
                  </p>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.12 JURISDICTION</h2>
                  <ul>
                    <li className="font-medium fs-5">This Policy shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in New Delhi.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.13 Data Deletion & Retention Policy</h2>
                  <p className="font-medium fs-5">This section is to ensure the responsible handling, retention, and deletion of personal and project-related data of students - in compliance with applicable data protection laws and internal governance policies. This policy applies to:</p>
                  <ul>
                    <li className="font-medium fs-5">All students enrolled in the ARISE4U program who do not meet the qualifying criteria (e.g., minimum GPA of 8.5)</li>
                    <li className="font-medium fs-5">Their submitted project documentation, videos, pitch decks, and personal identifiers (PII)</li>
                  </ul>
                  <p className="font-medium fs-5 mt-3">The following data fields will be impacted:</p>
                  <ul>
                    <li className="font-medium fs-5">Full Name</li>
                    <li className="font-medium fs-5">Email Address</li>
                    <li className="font-medium fs-5">Phone Number</li>
                    <li className="font-medium fs-5">Institution/College Details</li>
                    <li className="font-medium fs-5">Project Title and Description</li>
                    <li className="font-medium fs-5">Uploaded Project Assets (Files, PPTs, Videos, etc.)</li>
                    <li className="font-medium fs-5">Assessment Scores</li>
                  </ul>

                  <h3 className="mt-4 mb-2 font-bold">Data Retention Period (Before Deletion)</h3>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead style={{ backgroundColor: '#f2f2f2' }}>
                        <tr>
                          <th className="font-bold">DATA TYPE</th>
                          <th className="font-bold">RETENTION DURATION</th>
                          <th className="font-bold">REASON</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Student PIL</td>
                          <td>60 Days post result appeals</td>
                          <td>Reconciliation</td>
                        </tr>
                        <tr>
                          <td>Project Submissions</td>
                          <td>60 Days post result, internal reference</td>
                          <td>Validation</td>
                        </tr>
                        <tr>
                          <td>Assessment Scores</td>
                          <td>60 days post result</td>
                          <td>Scoring audits, documentation</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className="font-medium fs-5 mt-3">Note: After the 60-day retention period, data will be permanently deleted.</p>

                  <h3 className="mt-4 mb-2 font-bold">Deletion Procedure</h3>
                  <h4 className="mt-3 font-bold fs-5">Identification of Participants</h4>
                  <p className='font-medium fs-5'>Post-evaluation, students who score below the qualifying band (e.g., &lt; 8.5 GPA) are flagged as "non-qualified" in the system.</p>
                  <p className='font-medium fs-5'>The final list of such participants is reviewed and locked by the Program Lead.</p>

                  <h4 className="mt-3 font-bold fs-5">Data Archival (Optional)</h4>
                  <p className='font-medium fs-5'>Before deletion, anonymized summary-level data (scores, participation metrics) may be retained for reporting purposes.</p>
                  <p className='font-medium fs-5'>No personally identifiable information (PII) will be included.</p>

                  <h4 className="mt-3 font-bold fs-5">Deletion Execution</h4>
                  <p className='font-medium fs-5'>The Data Ops team, under guidance of the Program Manager and with approval from HCLTech Career Shaper’s Data Protection Officer, will:</p>
                  <ul>
                    <li className="font-medium fs-5">Remove student records from the backend database.</li>
                    <li className="font-medium fs-5">Delete project files from cloud storage/server locations.</li>
                    <li className="font-medium fs-5">Wipe assessment scores and submissions from associated platforms (e.g., LMS, CMS, drive folders).</li>
                  </ul>

                  <h4 className="mt-3 font-bold fs-5">Tools & Validation</h4>
                  <p className='font-medium fs-5'>Deletion scripts or secure admin panels will be used.</p>
                  <p className='font-medium fs-5'>A validation report will be generated and archived by the Data Privacy Lead confirming data deletion completion.</p>

                  <h4 className="mt-3 font-bold fs-5">Data Backup</h4>
                  <p className='font-medium fs-5'>Backups taken before deletion will be retained for 30 days only and then purged.</p>
                  <p className='font-medium fs-5'>These backups are stored in an encrypted and access-controlled environment.</p>

                  <h4 className="mt-3 font-bold fs-5">Compliance & Governance</h4>
                  <p className='font-medium fs-5'>Aligned with:</p>
                  <ul>
                    <li className="font-medium fs-5">[✔] GDPR (if applicable)</li>
                    <li className="font-medium fs-5">[✔] IT Act, India</li>
                    <li className="font-medium fs-5">[✔] Internal Data Protection Policy of HCLTech, Pearson India, and MeitY Startup Hub</li>
                  </ul>

                  <h4 className="mt-3 font-bold fs-5">Exceptions & Approvals</h4>
                  <p className='font-medium fs-5'>Any deviation from this policy (e.g., retention extension due to legal dispute or internal audit) must be approved by the Program Governance Council.</p>

                  <h4 className="mt-3 font-bold fs-5">Ownership & Responsibility</h4>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead style={{ backgroundColor: '#f2f2f2' }}>
                        <tr>
                          <th className="font-bold">ROLE</th>
                          <th className="font-bold">RESPONSIBILITY</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Program Lead</td>
                          <td>Identification of non-qualified students</td>
                        </tr>
                        <tr>
                          <td>Data Ops</td>
                          <td>Execution of deletion</td>
                        </tr>
                        <tr>
                          <td>DPO</td>
                          <td>Compliance check and final approvals</td>
                        </tr>
                      </tbody>
                    </table>
                    <p className='font-medium fs-5'>
                      Partner Stakeholders (Pearson / MeitY Hub) Observational compliance </p>
                  </div>
                </>
              </div>
            </div>
          </div>
        </section>

        {/* You had this commented out, but I'll leave it here */}
        {/* <Footer /> */}
      </>

      {/* Spinner for loading state */}
      {isLoading && <Spinner />}
    </>
  );
};

export default PrivacyPolicy;